import { Injectable } from '@angular/core';
import { StopTypesService } from '@control-tower/platform-loads';
import { LoggerService } from '@pf/shared-services';
import {
    AbstractTypeEntityFacade,
    TypeEntityStore,
} from '@pf/shared/util-platform';
import { TypeEntityTypes } from '@pf/shared-common';

@Injectable()
export class StopTypeFacade extends AbstractTypeEntityFacade<StopTypesService> {
    constructor(
        stopTypesService: StopTypesService,
        store: TypeEntityStore,
        logger: LoggerService
    ) {
        super(
            store,
            logger,
            stopTypesService,
            'stopTypeGetAll',
            TypeEntityTypes.StopType
        );
    }
}
